import {convictionPartiesList, convictionTypes, YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import DynamicItemHeadingComponent from "@components/common/ui-elements/headings/dynamic-item-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableCustomDateTimePickerBlock
    from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import {CONVICTION_CODES} from "@constants/dropdown-choices";

export default function PolicyHolderConvictionForm(
    {
        conviction,
        driverIndex,
        convictionIndex,
        motorConvictionsListPropName,
        handlePolicyHolderConvictionPropChange ,
        addPolicyHolderConviction ,
        removePolicyHolderConviction,
    }
) {

    const generateName = (prop) => {
        return `${motorConvictionsListPropName}[${convictionIndex}][${prop}]`;
    }

    const generateIdPrefix = (prop) => {
        return `${motorConvictionsListPropName}-${convictionIndex}-${prop}-`;
    }

    return (
        <div className="policy-holder-conviction-block hidden-box row">

            <DynamicItemHeadingComponent
                text="Conviction"
                itemIndex={convictionIndex + 1}
                onRemoveIconClick={(e) => removePolicyHolderConviction(convictionIndex)}
            />


            {/* Date of driving conviction or offence (if conviction still pending)* */}

            <ScrollableCustomDateTimePickerBlock
                containerCssClass="col-12 py-3 extra"
                labelText="Date of driving conviction or offence (if conviction still pending)*"
                required={true}
                controlName={generateName('date')}
                value={conviction.date}
                onChange={(e) => handlePolicyHolderConvictionPropChange(convictionIndex, 'date', e.target.value)}
            />


            {/* Conviction code */}

            <ScrollableDropdownBlock
                controlName={generateName('code')}
                containerCssClass="col-12 py-3 "
                labelText="Conviction code"
                required={true}
                options={CONVICTION_CODES}
                selectedValues={conviction.code}
                onChange={(e) => handlePolicyHolderConvictionPropChange(convictionIndex, 'code', e.target.value)}
                helpText=""
            />

            {/* Points incurred */}

            <ScrollableTextBoxBlock
                type="number"
                containerCssClass="col-12 py-3 extra"
                labelText="Points incurred"
                required={true}
                controlName={generateName('points')}
                value={conviction.points}
                onChange={(e) => handlePolicyHolderConvictionPropChange(convictionIndex, 'points', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />



            {/* Fine incurred (if no fine, enter 0) */}

            <ScrollableTextBoxBlock
                type="number"
                containerCssClass="col-12 py-3 extra"
                labelText="Fine incurred (if no fine, enter 0)"
                required={true}
                controlName={generateName('fines')}
                value={conviction.fines}
                onChange={(e) => handlePolicyHolderConvictionPropChange(convictionIndex, 'fines', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />



            {/*  Ban length in months (if no ban, enter 0) */}

            <ScrollableTextBoxBlock
                type="number"
                containerCssClass="col-12 py-3 extra"
                labelText=" Ban length in months (if no ban, enter 0)"
                required={true}
                controlName={generateName('banLengthInMonths')}
                value={conviction.banLengthInMonths}
                onChange={(e) => handlePolicyHolderConvictionPropChange(convictionIndex, 'banLengthInMonths', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />

            {/* Was the driver breathalysed? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 extra"
                labelText="Was the driver breathalysed?"
                required={true}
                controlName={generateName('wasDriverBreathalysed')}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={conviction.wasDriverBreathalysed}
                onChange={(e) => handlePolicyHolderConvictionPropChange(convictionIndex, 'wasDriverBreathalysed', e.target.value)}
            />

            {/* Was the offence accident-related? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 extra"
                labelText="Was the offence accident-related?"
                required={true}
                controlName={generateName('wasOffenceAccidentRelated')}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={conviction.wasOffenceAccidentRelated}
                onChange={(e) => handlePolicyHolderConvictionPropChange(convictionIndex, 'wasOffenceAccidentRelated', e.target.value)}
            />

        </div>
    );

}